// import { Box, Card, CardContent, Container, Typography } from '@mui/material';
// import React, { useRef } from 'react'
// import { useCookies } from 'react-cookie';
// import { config } from '../../config/config';
// import { indiaTopCities } from '../../common/common';
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/navigation";
// import { Navigation, Autoplay } from "swiper/modules";
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import "./TopCities.css";

// const TopCities = () => {
//     const [cookies, setCookies] = useCookies();
//     const prevRef = useRef(null);
//     const nextRef = useRef(null);

//     const setCity = (value) => {
//         // Create updated cookie value
//         const updatedCookieValue = JSON.stringify({
//             ...cookies[config.preferencesCookie],
//             city: value,
//         });

//         setCookies(config.preferencesCookie, updatedCookieValue, {
//             path: "/",
//             maxAge: 3000000,
//             sameSite: "strict",
//         });
//     };
//     return (
//         <>
//             <Box component='section' sx={{ py: 6, textAlign: "center", backgroundColor: "#F9F9F9" }}>
//                 <Container fixed>
//                     {/* Heading */}
//                     <Box className="primary-heading-container">
//                         <Typography variant="h2" className="section-primary-heading">
//                             Find Your Dream Properties In{" "}
//                             {cookies[config.preferencesCookie]?.city
//                                 ? cookies[config.preferencesCookie]?.city
//                                 : "Your Preferred City"}
//                         </Typography>
//                     </Box>
//                     <div className="carousel-container">
//                         <Swiper
//                             modules={[Navigation, Autoplay]}
//                             spaceBetween={25}
//                             slidesPerView={5}
//                             loop={true}
//                             navigation={{
//                                 prevEl: prevRef.current,
//                                 nextEl: nextRef.current,
//                             }}
//                             autoplay={{ delay: 3000 }}
//                             breakpoints={{
//                                 0: { slidesPerView: 2 },
//                                 600: { slidesPerView: 3 },
//                                 1000: { slidesPerView: 4 },
//                             }}
//                             onInit={(swiper) => {
//                                 swiper.params.navigation.prevEl = prevRef.current;
//                                 swiper.params.navigation.nextEl = nextRef.current;
//                                 swiper.navigation.init();
//                                 swiper.navigation.update();
//                             }}
//                         >
//                             {indiaTopCities.map((item) => (
//                                 <SwiperSlide key={item.name}>
//                                     <Card
//                                         sx={{
//                                             margin: "15px 5px",
//                                             boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
//                                             borderRadius: "15px",
//                                             border: "1px solid #E0E0E0",
//                                             background: "#FFF",
//                                             transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                                             "&:hover": {
//                                                 transform: "translateY(-5px)",
//                                                 boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)",
//                                             },
//                                             cursor: "pointer"
//                                         }}
//                                         onClick={() => setCity(item.name)}
//                                     >
//                                         <CardContent
//                                             sx={{
//                                                 display: "flex",
//                                                 flexDirection: "column",
//                                                 alignItems: "center",
//                                                 justifyContent: "center",
//                                                 padding: "20px",
//                                             }}
//                                         >
//                                             {/* Icon/Image */}
//                                             <Box
//                                                 sx={{
//                                                     display: "flex",
//                                                     justifyContent: "center",
//                                                     alignItems: "center",
//                                                     width: { md: "60px", xs: "40px" },
//                                                     height: { md: "60px", xs: "40px" },
//                                                     background: "#F5F5F5",
//                                                     borderRadius: "50%",
//                                                     padding: "10px",
//                                                     mb: "10px",
//                                                 }}
//                                             >
//                                                 <img
//                                                     src={item.svg}
//                                                     alt={item.name}
//                                                     style={{ width: "70%", height: "auto" }}
//                                                 />
//                                             </Box>

//                                             {/* City Name */}
//                                             <Typography
//                                                 variant="subtitle1"
//                                                 sx={{
//                                                     color: "#333",
//                                                     fontSize: { md: "16px", xs: "12px" },
//                                                     fontWeight: 600,
//                                                     textAlign: "center",
//                                                     fontFamily: "Mulish, sans-serif",
//                                                 }}
//                                             >
//                                                 {item.name}
//                                             </Typography>
//                                         </CardContent>
//                                     </Card>
//                                 </SwiperSlide>
//                             ))}

//                         </Swiper>
//                         {/* Custom Navigation Buttons at the Bottom */}
//                         {/* <div className="carousel-controls">
//                             <button ref={prevRef} className="carousel-button prev"><ArrowBackIcon className="arrow-icon left-icon" /></button>
//                             <button ref={nextRef} className="carousel-button next"><ArrowForwardIcon className="arrow-icon right-icon" /></button>
//                         </div> */}
//                     </div>
//                 </Container>
//             </Box>
//         </>
//     )
// }

// export default TopCities

























import { Box, Card, CardContent, Container, Typography, IconButton } from '@mui/material';
import React, { useRef } from 'react'
import { useCookies } from 'react-cookie';
import { config } from '../../config/config';
import { indiaTopCities } from '../../common/common';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PublicIcon from '@mui/icons-material/Public';

const TopCities = () => {
    const [cookies, setCookies] = useCookies();
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);

    const setCity = (value) => {
        // Create updated cookie value
        const updatedCookieValue = JSON.stringify({
            ...cookies[config.preferencesCookie],
            city: value,
        });

        setCookies(config.preferencesCookie, updatedCookieValue, {
            path: "/",
            maxAge: 3000000,
            sameSite: "strict",
        });
    };

    return (
        <>
            <Box
                component='section'
                sx={{
                    py: { xs: 4, sm: 5, md: 6 },
                    backgroundColor: "#ffffff",
                    borderTop: '1px solid #e5e7eb',
                    borderBottom: '1px solid #e5e7eb',
                }}
            >
                <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
                    {/* Heading */}
                    <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4, md: 5 } }}>
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                backgroundColor: 'rgba(220, 38, 38, 0.1)',
                                color: '#dc2626',
                                px: 2,
                                py: 0.5,
                                borderRadius: '20px',
                                fontSize: '12px',
                                fontWeight: 600,
                                letterSpacing: '0.5px',
                                mb: 2,
                            }}
                        >
                            <PublicIcon sx={{ fontSize: 14, mr: 0.5 }} />
                            Top Cities
                        </Box>

                        <Typography
                            variant="h2"
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: "24px", sm: "30px", md: "36px" },
                                color: '#111827',
                                mb: 1,
                                lineHeight: 1.2,
                            }}
                        >
                            Find Your Dream Properties In{' '}
                            <Box
                                component="span"
                                sx={{
                                    color: '#dc2626',
                                    position: 'relative',
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        bottom: '2px',
                                        left: 0,
                                        width: '100%',
                                        height: '4px',
                                        backgroundColor: 'rgba(220, 38, 38, 0.1)',
                                        borderRadius: '2px',
                                    }
                                }}
                            >
                                {cookies[config.preferencesCookie]?.city || "Your Preferred City"}
                            </Box>
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: '#6b7280',
                                fontSize: { xs: "14px", sm: "15px", md: "16px" },
                                maxWidth: '600px',
                                mx: 'auto',
                                lineHeight: 1.6,
                            }}
                        >
                            Discover properties in India's most sought-after cities with premium real estate options
                        </Typography>
                    </Box>

                    {/* Swiper Container with Arrows */}
                    <Box sx={{
                        position: 'relative',
                        '& .swiper': {
                            padding: '20px 0 40px !important',
                        },
                    }}>
                        {/* Left Arrow */}
                        <IconButton
                            ref={prevRef}
                            sx={{
                                position: 'absolute',
                                left: { xs: '-10px', sm: '-20px', md: '-30px' },
                                top: '50%',
                                transform: 'translateY(-50%)',
                                backgroundColor: 'white',
                                border: '1px solid #e5e7eb',
                                width: { xs: 36, sm: 40, md: 44 },
                                height: { xs: 36, sm: 40, md: 44 },
                                zIndex: 10,
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                '&:hover': {
                                    backgroundColor: '#dc2626',
                                    color: 'white',
                                    borderColor: '#dc2626',
                                    transform: 'translateY(-50%) scale(1.05)',
                                },
                                transition: 'all 0.2s ease',
                            }}
                        >
                            <ArrowBackIcon sx={{ fontSize: { xs: 18, sm: 20, md: 22 } }} />
                        </IconButton>

                        {/* Right Arrow */}
                        <IconButton
                            ref={nextRef}
                            sx={{
                                position: 'absolute',
                                right: { xs: '-10px', sm: '-20px', md: '-30px' },
                                top: '50%',
                                transform: 'translateY(-50%)',
                                backgroundColor: 'white',
                                border: '1px solid #e5e7eb',
                                width: { xs: 36, sm: 40, md: 44 },
                                height: { xs: 36, sm: 40, md: 44 },
                                zIndex: 10,
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                '&:hover': {
                                    backgroundColor: '#dc2626',
                                    color: 'white',
                                    borderColor: '#dc2626',
                                    transform: 'translateY(-50%) scale(1.05)',
                                },
                                transition: 'all 0.2s ease',
                            }}
                        >
                            <ArrowForwardIcon sx={{ fontSize: { xs: 18, sm: 20, md: 22 } }} />
                        </IconButton>

                        <Swiper
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                            modules={[Navigation, Autoplay]}
                            spaceBetween={20}
                            slidesPerView={5}
                            loop={true}
                            navigation={{
                                prevEl: prevRef.current,
                                nextEl: nextRef.current,
                            }}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true,
                            }}
                            breakpoints={{
                                0: { slidesPerView: 2, spaceBetween: 16 },
                                600: { slidesPerView: 3, spaceBetween: 20 },
                                900: { slidesPerView: 4, spaceBetween: 24 },
                                1200: { slidesPerView: 5, spaceBetween: 24 },
                            }}
                            onInit={(swiper) => {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                                swiper.navigation.init();
                                swiper.navigation.update();
                            }}
                        >
                            {indiaTopCities.map((item) => (
                                <SwiperSlide key={item.name}>
                                    <Card
                                        sx={{
                                            height: '100%',
                                            borderRadius: '16px',
                                            border: '1px solid #f3f4f6',
                                            background: 'white',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            '&:hover': {
                                                transform: 'translateY(-8px)',
                                                boxShadow: '0 20px 40px rgba(220, 38, 38, 0.15)',
                                                borderColor: '#dc2626',
                                                '& .city-icon-container': {
                                                    transform: 'scale(1.1)',
                                                    backgroundColor: 'rgba(220, 38, 38, 0.1)',
                                                },
                                                '& .city-name': {
                                                    color: '#dc2626',
                                                },
                                                '&::before': {
                                                    width: '100%',
                                                }
                                            },
                                            '&::before': {
                                                content: '""',
                                                position: 'absolute',
                                                bottom: 0,
                                                left: 0,
                                                width: '0%',
                                                height: '3px',
                                                backgroundColor: '#dc2626',
                                                transition: 'width 0.3s ease',
                                                borderRadius: '0 0 16px 16px',
                                            }
                                        }}
                                        onClick={() => setCity(item.name)}
                                    >
                                        <CardContent
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: { xs: '20px 16px', sm: '24px 20px' },
                                                height: '100%',
                                            }}
                                        >
                                            {/* Icon/Image Container */}
                                            <Box
                                                className="city-icon-container"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    width: { xs: "56px", sm: "64px", md: "72px" },
                                                    height: { xs: "56px", sm: "64px", md: "72px" },
                                                    background: 'linear-gradient(135deg, #fee2e2, #fecaca)',
                                                    borderRadius: "50%",
                                                    padding: "12px",
                                                    mb: "16px",
                                                    transition: 'all 0.3s ease',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    '&::after': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.1), rgba(220, 38, 38, 0.05))',
                                                        borderRadius: '50%',
                                                    }
                                                }}
                                            >
                                                {item.svg ? (
                                                    <img
                                                        src={item.svg}
                                                        alt={item.name}
                                                        style={{
                                                            width: "60%",
                                                            height: "auto",
                                                            zIndex: 1,
                                                            position: 'relative'
                                                        }}
                                                    />
                                                ) : (
                                                    <LocationOnIcon
                                                        sx={{
                                                            fontSize: { xs: 28, sm: 32, md: 36 },
                                                            color: '#dc2626',
                                                            zIndex: 1,
                                                            position: 'relative'
                                                        }}
                                                    />
                                                )}
                                            </Box>

                                            {/* City Name */}
                                            <Typography
                                                className="city-name"
                                                variant="subtitle1"
                                                sx={{
                                                    color: "#374151",
                                                    fontSize: { xs: "14px", sm: "16px", md: "18px" },
                                                    fontWeight: 700,
                                                    textAlign: "center",
                                                    mb: 1,
                                                    transition: 'color 0.3s ease',
                                                }}
                                            >
                                                {item.name}
                                            </Typography>

                                            {/* City Info */}
                                            {item.info && (
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: "#6b7280",
                                                        fontSize: { xs: "11px", sm: "12px" },
                                                        textAlign: "center",
                                                        lineHeight: 1.4,
                                                        mt: 0.5,
                                                    }}
                                                >
                                                    {item.info}
                                                </Typography>
                                            )}

                                            {/* Click Indicator */}
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 0.5,
                                                    mt: 2,
                                                    opacity: 0.7,
                                                    transition: 'opacity 0.3s ease',
                                                    '&:hover': {
                                                        opacity: 1,
                                                    }
                                                }}
                                            >
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        color: "#dc2626",
                                                        fontSize: "11px",
                                                        fontWeight: 600,
                                                        letterSpacing: '0.5px',
                                                    }}
                                                >
                                                    Click to Explore
                                                </Typography>
                                                <ArrowForwardIcon sx={{ fontSize: 12, color: '#dc2626' }} />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Box>

                    {/* City Count */}
                    <Box sx={{ textAlign: 'center', mt: 4 }}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#6b7280',
                                fontSize: { xs: '13px', sm: '14px' },
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 1,
                            }}
                        >
                            <LocationOnIcon sx={{ fontSize: { xs: 14, sm: 16 }, color: '#dc2626' }} />
                            Showing {indiaTopCities.length} top cities across India
                        </Typography>
                    </Box>

                    {/* City Selection Status */}
                    {cookies[config.preferencesCookie]?.city && (
                        <Box
                            sx={{
                                textAlign: 'center',
                                mt: 3,
                                animation: 'fadeIn 0.5s ease',
                                '@keyframes fadeIn': {
                                    '0%': { opacity: 0, transform: 'translateY(10px)' },
                                    '100%': { opacity: 1, transform: 'translateY(0)' },
                                }
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#dc2626',
                                    fontSize: { xs: '14px', sm: '15px' },
                                    fontWeight: 600,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    backgroundColor: 'rgba(220, 38, 38, 0.1)',
                                    px: 2,
                                    py: 1,
                                    borderRadius: '20px',
                                }}
                            >
                                <LocationOnIcon sx={{ fontSize: 16 }} />
                                Currently selected: {cookies[config.preferencesCookie]?.city}
                            </Typography>
                        </Box>
                    )}
                </Container>
            </Box>
        </>
    )
}

export default TopCities;